
import React from 'react';
import {Modal2} from "../components/modal";
import {mxMemberToFundingSource, UpdateFundingSource} from "./actions";
import {is_master_account} from "../../lib/dwolla/constants";

const MX_STATE = {
  INIT: "INIT",
  FETCHING_TOKEN: "FETCHING_TOKEN",
  FLOW: "FLOW",
  ADDING_PAYMENT_SOURCE: "ADDING_PAYMENT_SOURCE",
  DONE: "DONE",
  ERROR: "ERROR",
};

const MxConnect = props => {
  const component = props.component;
  if (component.state.mx_flow !== MX_STATE.FLOW) {
    return null;
  }
  const url = component.state.url;
  const button_list = [
    {
      cb: props.onClose,
      label: "Cancel",
    }
  ];
  const iframe_style = {
    width: "650px",
    height: "650px",
  }
  const container_style = {
    width: "40rem",
    height: "60rem",
  }
  const body_style = {
    padding: "0",
  }
  return (
    <Modal2
      container_style={container_style}
      body_style={body_style}
      buttonList={button_list}>
      <iframe
        border='0'
        frame='0'
        frameBorder='0'
        style={iframe_style}
        marginHeight='0'
        marginWidth='0'
        src={url}
        title='MX Connect Widget'/>
    </Modal2>);

};

/**
 * Returns true if {@param dwolla} has a funding source that's not the
 * TDA Master account.
 */
const dwolla_has_funding_source = dwolla => {
  let result = false;
  Object.keys(dwolla.funding_source).forEach(id => {
    const source = dwolla.funding_source[id];
    if (!is_master_account(source.name)) {
      result = true;
    }
  });
  return result;
};

const update_mx_funding_source = (component) => {
  const dwolla = component.props.dwolla['0000'];
  const user_guid = dwolla.customer.mx_user_id;
  let funding_source_id;
  const result = {
    mx_state: null,
    dwolla: null,
    funding_source_id: null,
  }
  return new Promise(resolve => {

    mxMemberToFundingSource(component.props.token, component.props.onboarding_token, component.state.member_guid, user_guid)
      .then(result => {
        funding_source_id = result.funding_source_id;
        const set_default = !dwolla_has_funding_source(dwolla);

        const metadata = {
          mx_account_guid: result.acct_guid,
          mx_member_guid: result.member_guid,
          routing_number: result.routing_number,
          account_number: result.account_number,
        }

        return UpdateFundingSource(
          component.props.token,
          component.props.onboarding_token,
          funding_source_id,
          set_default,
          metadata);
      })
      .then(({dwolla}) => {
        result.funding_source_id = funding_source_id;
        result.dwolla = dwolla;
        return resolve(result);
      })
      .catch(err => {
        console.log("Error", err);
        result.mx_state = MX_STATE.ERROR;
        result.error = err;
        return resolve(result);
      })

  });
}

export { MxConnect, MX_STATE, update_mx_funding_source };
